module.exports = __webpack_public_path__ + "static/media/exploreCsvIcon.376f9e59.svg";